// extracted by mini-css-extract-plugin
module.exports = {"autoCompleteWithDefaultBackground":"remoteAutoComplete_autoCompleteWithDefaultBackground__9IpEz"};